export default __webpack_public_path__ + "static/media/Legguards of the Dauntless.a86de2c6.jpg";